export default "/images/gobierno-espana-logo.png?9bd533bed89a5bab8d2f58c709c5a3ad";